/**
 * Factory which generates standard model operations.
 */
import Operation from "core/models/Operation";
import $ from "jquery";
import _ from "underscore";
import s from "underscore.string";
import modals from "core/views/modals";
import BaseRouter from "core/base/Router";
var ModelOperations = {
  /**
   * Generates a save-new operation for the given item.
   * @param  {string} modelName A title case version of the model name to use in messages.
   * @param  {FormView} formView   The form view which is used to save the model.
   * @param {Backbone.Collection} collection The collection to which models will be added on success.
   * @param  {Boolean} [useModel]   Passed to the `FormView.save` function.
   * @return {Operation}            An operation which can be attached to a control for creating the model.
   */
  create: function (modelName, formView, collection, useModel) {
    return new Operation({
      id: "save-new-" + s.slugify(modelName),
      text: "Create",
      icon: "floppy-disk",
      action: function (model) {
        var deferred = new $.Deferred();

        formView
          .save(useModel)
          .done(function () {
            collection.add(model);
            BaseRouter.relativeNavigate("Edit/" + model.id, {
              trigger: true,
              replace: true,
            });
            deferred.resolve(model, modelName + " created successfully.");
          })
          .fail(function (requestSent, responseBack, error) {
            //Get the errors out of the JSON mess returned
            if (
              responseBack &&
              responseBack.responseJSON &&
              responseBack.responseJSON.errors &&
              responseBack.responseJSON.errors[0].meta &&
              responseBack.responseJSON.errors[0].meta.debug
            ) {
              var errorsReturned =
                responseBack.responseJSON.errors[0].meta.debug.Errors;
              $(".input-error-message").remove();
              $(".has-error").removeClass("has-error");
              // Append error message on the screen
              _.each(errorsReturned, function (errorValue, errorKey) {
                var classToFind = ".form-input-view-" + s.slugify(errorKey);
                var $divContainingError = $(classToFind);
                $divContainingError.addClass("has-error");
                $divContainingError.append(
                  "<div class='input-error-message'></div>"
                );
                _.each(errorValue, function (error) {
                  $(classToFind)
                    .find(".input-error-message")
                    .append("<p class='help-block'> " + error.message + "</p>");
                });
              });
            }
            deferred.reject("Error saving " + modelName.toLowerCase() + ".");
          });
        return deferred.promise();
      },
    });
  },

  /**
   * Generates a save operation for the given item.
   * @param  {string} modelName A title case version of the model name to use in messages.
   * @param  {FormView} formView   The form view which is used to save the model.
   * @param  {Boolean} [useModel]   Passed to the `FormView.save` function.
   * @return {Operation}            An operation which can be attached to a control for saving the model.
   */
  save: function (modelName, formView, useModel) {
    return new Operation({
      id: "save-" + s.slugify(modelName),
      text: "Save",
      icon: "floppy-disk",
      action: function (model) {
        var deferred = new $.Deferred();

        formView
          .save(useModel)
          .done(function () {
            deferred.resolve(model, modelName + " saved successfully.");
          })
          .fail(function () {
            deferred.reject("Error saving " + modelName.toLowerCase() + ".");
          });

        return deferred.promise();
      },
    });
  },

  /**
   * Generates a delete operation for the given item.
   * @param  {string} modelName A title case version of the model name to use in messages.
   * @param {Backbone.Collection} collection The collection from which the model will be removed.
   * @return {Operation}            An operation which can be attached to a control for deleting the model.
   */
  destroy: function (modelName, collection) {
    return new Operation({
      id: "delete-" + s.slugify(modelName),
      icon: "remove",
      text: "Delete",
      action: function (model) {
        var deferred = new $.Deferred();

        modals.confirm(
          "Delete " + modelName,
          "Are you sure you want to delete this " +
            modelName.toLowerCase() +
            "?",
          {
            type: "danger",
            text: "Delete",
          },
          function () {
            model.destroy({
              success: function () {
                collection.remove(model);
                deferred.resolve(model, modelName + " deleted.");
                setTimeout(function () {
                  BaseRouter.relativeNavigate("", {
                    trigger: true,
                  });
                }, 800);
              },
              error: function () {
                deferred.reject(
                  "Error deleting " + modelName.toLowerCase() + "."
                );
              },
            });
          },
          "Cancel",
          function () {
            deferred.reject(false);
          }
        );

        return deferred.promise();
      },
    });
  },
};

export default ModelOperations;



//////////////////
// WEBPACK FOOTER
// ./public/js/core/operations/ModelOperations.js
// module id = 103
// module chunks = 1